import { render, staticRenderFns } from "./Mentions.vue?vue&type=template&id=0241bcd2&scoped=true&"
import script from "./Mentions.vue?vue&type=script&lang=ts&"
export * from "./Mentions.vue?vue&type=script&lang=ts&"
import style0 from "./Mentions.vue?vue&type=style&index=0&id=0241bcd2&lang=scss&scoped=true&"
import style1 from "./Mentions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0241bcd2",
  null
  
)

export default component.exports